const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-klaviyo-signup-form'] = {
        c: () => require('partner/modules/hei-klaviyo-signup-form/hei-klaviyo-signup-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-klaviyo-signup-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-klaviyo-signup-form'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-klaviyo-signup-form|hei-klaviyo-signup-form'] = {
                c: () => require('partner/modules/hei-klaviyo-signup-form/hei-klaviyo-signup-form.view.tsx'),
                cn: '__local__-__local__-hei-klaviyo-signup-form'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };